import React from 'react'
import { NavLink } from 'react-router-dom'
import { Button } from '@material-ui/core'

const MenulateralNovoItems = props =>{

    const buttonStyle = {
        justifyContent:"start",
        width:"100%",
        paddingLeft:"54px",
        fontSize:"0.75rem",
        margin:"4px 0",
        fontFamily:"inherit"
    }

    const  navLinkStyle = {
        color:"#000000",
        fontFamily:"flama-book",
        textDecoration:"none"
    }

    const navLinkActivedStyle = {
        fontFamily:"flama-medium",
    }

    return <NavLink activeStyle={navLinkActivedStyle} style={navLinkStyle} to={props.link}> <Button style={buttonStyle}>{props.children} </Button> </NavLink> 
    
    
}


export default MenulateralNovoItems